export default "__VITE_ASSET__CpZ9GXrr__"